export const getRequiredModifiers = (modGroup) => {
  let reqModifiers = [];
  modGroup.modifier_items.forEach((item) => {
    console.log(item, "moditems");
    if (item.selectedQty > 0 && modGroup.minQty > 0 && reqModifiers.length <= modGroup.minQty) {
      reqModifiers.push(item.id);
    }
  })
  return reqModifiers;
}

export const craeteFnBPayloadForOrdersEndpoint = (cart) => {
  const getModifiers = (modifierGroups) => {
    let modifiers = [];
    modifierGroups.forEach((modGrp) => {
      let requiredModifiers = getRequiredModifiers(modGrp);
      modGrp.modifier_items.forEach((modItem) => {
        if (modItem.selectedQty > 0) {
          modifiers.push({
            id: modItem.id,
            quantity: modItem.selectedQty,
            tabid: modGrp.tabid,
            discountItem: modItem.discountItem,
            ...(modItem?.discountCode != null && { discountCode: modItem.discountCode }),
            required: requiredModifiers.includes(modItem.id),
            modifierid: modItem.modifierid
          });
        }
      });
    });
    return modifiers;
  };

  let fnbOrderData = [];
  cart.map((eachFnb) => {
    var eachFnbObject;
    if (eachFnb.fnbs_alternateitems.length == 0) {
      eachFnbObject = {
        inSeatDelivery: eachFnb.inSeatDelivery,
        offerItems: false,
        id: eachFnb.id,
        quantity: eachFnb.selectedQty,
        tabId: eachFnb.tabId,
        fnbid: eachFnb.fnbid,
        modifiers: getModifiers(eachFnb.modifierGroups),
        smartModifiers: eachFnb.smartModifiers,
        promotionid: null,
        specialinstructions: "",
        variablepriceincents: null,
        type: "concession",
        suggestion: {},
        discountItem: eachFnb.discountItem,
        ...(eachFnb?.discountCode != null && { discountCode: eachFnb.discountCode }),
        disableOfferItems: true,
        recognitionId: eachFnb?.recognitionid
      };
      if (window.constant.ENABLE_VOUCHERS == "true") {
        if (eachFnb.voucherCodes) {
          eachFnbObject.voucherCode = eachFnb.vouchersCodesApplied;
          eachFnbObject.dealId = eachFnb.voucherDealId;
          eachFnbObject.voucherType = eachFnb.voucherType;
        }
      }
      fnbOrderData.push(eachFnbObject);
    } else {
      eachFnb.fnbs_alternateitems.map((eachAlternateItem) => {
        if (eachAlternateItem.selectedQty != 0) {
          var tempEachFnbObject = {
            inSeatDelivery: eachAlternateItem.inSeatDelivery,
            offerItems: false,
            id: eachAlternateItem.id,
            quantity: eachAlternateItem.selectedQty,
            tabId: eachAlternateItem.tabId,
            fnbid: eachAlternateItem.fnbid,
            modifiers: getModifiers(eachAlternateItem.modifierGroups),
            smartModifiers: eachAlternateItem.smartModifiers,
            promotionid: null,
            specialinstructions: "",
            variablepriceincents: null,
            type: "concession",
            suggestion: {},
            discountItem: eachAlternateItem.discountItem,
            ...(eachAlternateItem?.discountCode != null && { discountCode: eachAlternateItem.discountCode }),
            disableOfferItems: true,
          };
          if (window.constant.ENABLE_VOUCHERS == "true") {
            if (eachFnb.voucherCodes) {
              eachFnbObject.voucherCode = eachFnb.vouchersCodesApplied;
              eachFnbObject.dealId = eachFnb.voucherDealId;
              eachFnbObject.voucherType = eachFnb.voucherType;
            }
          }
          fnbOrderData.push(tempEachFnbObject);
        }
      });
    }
  });
  return fnbOrderData;
};
